var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 16.9706,
    width: 24,
    height: 24,
    transform: "rotate(-45 0 16.9706)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_83_52",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_83_52",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACX0lEQVRIDeWUz2sTURDHZ3ZTIQerR/8BT61FUJGCV2MqeLH4B4hI0uZvEExAsRcPQpMKgrceFVpt0xTrQamHtCAoePAfUI/eBHfHz9tkN29psGl6EpOZndn59Z2Z9xKRf/2j6QCta/ZVTb7EIvXFju6n9uPKICug8sNUbgQq3WbZXq1ctYuZ7xhKBmAmz1wdE1EmmbNAuq2yvV4u2yVnH5ezFT2+ZcXiT/lOoZNwQjgjAENePqjKvWpb36AfiagxiOccmqypwgTZZM5LUAq0i+9RtaPrzj4KkzsIa5bsAp3uDSx5jeAEiKl2A5ORgMjJF2mV7KOoTGN1q0EcJJJGBsqtwpVigufIUIwvyjAykQQcoMvoa9y67adluzIslpi8+cmcTU7E8gDrDDdrBsDT6ClFKPxUZALpk7MFxO8w/f3FLX2XOg8ApI5ULl+3MxrJNKNO0e0Udre+WeQwcg2EscrLWltvugDynDgS//pLdNJwaJLVTQx+glvRiVgecl3Pcwrn8E3CPVKJsbkcxz0bT156h66ygz+3ogL+HFH8Nquo9UuR67m9zpyVJmLFRvxb/mLqlba+d3afC/4LF0dXRGocVHJovi+n9ycB/UUQSqOyoZ9yfu8lB9AsySzLO8uYXoinUpiOITm0cJqVA2DMO3SV7DMN6Eu3CuV2rAK+tLCln/v2QwX1ejHucAuRfOPeF3uW5OlWJex6VWNZWuiMXjjJ5pFNUIhlPi3Oof0GuQBvRCoN7nSX2LEoA6D4XcbnfGlYZVMiaVS3dW+sql7SAMDkFADr7KTOT33fi/nP1T8PYruzfWUCFQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.0c8907e8796e128af35e686f3195e83d.svg";
export { ForwardRef as ReactComponent };